import React, { useState, useEffect } from "react";
import "../style/ratepage.css";

// Assets
import btc from "../assets/btc.webp";
import eth from "../assets/eth.webp";
import usdt from "../assets/usdt.webp";
import bnb from "../assets/bnb.webp";

const ICON_MAP = {
  "BTC/USD": btc,
  "ETH/USD": eth,
  "USDT/USD": usdt,
  "BNB/USD": bnb,
};

export default function RatePage() {
  const [cryptoData, setCryptoData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const options = {
        method: 'GET',
        headers: {
          'X-Rapidapi-Key': '82f0a2c073mshc80b6b4a96395cdp11ed2bjsnae9413302238',
          'X-Rapidapi-Host': 'investing-com6.p.rapidapi.com'
        }
      };

      try {
        const response = await fetch('https://investing-com6.p.rapidapi.com/web-crawling/api/markets/cryptocurrency/majors?limit=8', options);
        const result = await response.json();
        
        const formattedData = result.map((item) => ({
          name: item.PairName,
          pair: item.Symbol || item.PairName,
          price: `USD ${parseFloat(item.Last).toLocaleString()}`,
          volume: item.Volume.toLocaleString(),
          change: `${item.ChgPct > 0 ? "+" : ""}${item.ChgPct}%`,
          icon: ICON_MAP[item.Symbol] || btc, 
          negative: item.ChgPct < 0,
        }));

        setCryptoData(formattedData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="crypto-container">
        <div className="loading-wrapper">
          <p>Fetching latest market rates...</p>
          <div className="progress-container">
            <div className="progress-bar-fill"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="crypto-container">
      {/* New Animated Heading Section */}
      <div className="market-header">
        <h1 className="animated-title">Live Crypto Market</h1>
        <p className="subtitle">Real-time updates from global exchanges</p>
      </div>

      <div className="crypto-grid">
        {cryptoData.map((item, i) => (
          <div className="crypto-card" key={i}>
            <div className="crypto-header">
              <div className="crypto-icon">
                <img src={item.icon} alt={`${item.name} logo`} />
              </div>
              <div>
                <h3 className="crypto-title">{item.name}</h3>
                <span className="crypto-pair">{item.pair}</span>
              </div>
            </div>

            <div className="crypto-price">{item.price}</div>

            <div className="crypto-footer">
              <span className="crypto-volume">{item.volume}</span>
              <span className={`crypto-change ${item.negative ? "red" : "green"}`}>
                {item.change}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}